var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"grey darken-3","flat":"","disabled":_vm.disabled,"loading":_vm.loading,"round":_vm.round,"large":_vm.large},on:{"click":function($event){_vm.$emit('click')}}},[(!_vm.label || _vm.labelWithIcon)?_c('v-icon',{attrs:{"medium":""}},[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.labelWithIcon)?_c('div',{staticClass:"mr-2"}):_vm._e(),_vm._v(" "),(!_vm.icon || _vm.label || _vm.labelWithIcon)?_c('div',[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ButtonAbort.vue?vue&type=template&id=244b2b28&scoped=true
// module id = 1871
// module chunks = 5